import { Plus } from '@phosphor-icons/react';
import { t } from 'i18next';
import { cloneElement, ReactElement, useMemo, useState } from 'react';

import { Button } from 'core/components';
import { PricingProfileRuleType } from 'pricing/enums';
import { IPricingProfile, IPricingProfileRule } from 'pricing/types';
import { Color } from 'theme/enums';

import { UpsertPricingProfileRule } from './UpsertPricingProfileRule';

interface IProps {
  pricingProfile: IPricingProfile;
  type: PricingProfileRuleType;
  rule?: IPricingProfileRule;
  buttonElement?: ReactElement;
  onSubmitSuccess: () => void;
  onRemoveSuccess?: () => void;
  disabled?: boolean;
}

export const UpsertPricingProfileRuleButton = ({
  pricingProfile,
  type,
  rule,
  buttonElement,
  onSubmitSuccess,
  onRemoveSuccess,
  disabled = false,
}: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const buttonLabel =
    type === PricingProfileRuleType.MARGIN
      ? t('buttonLabelAddMarginRule')
      : t('buttonLabelAddDiscountRule');

  const button = useMemo(() => {
    if (buttonElement) {
      return cloneElement(buttonElement, {
        onClick: disabled ? undefined : () => setIsOpen(true),
      });
    }

    return (
      <Button
        text={buttonLabel}
        color={Color.SUCCESS}
        startDecorator={<Plus />}
        onClick={() => setIsOpen(true)}
        disabled={disabled}
      />
    );
  }, [buttonElement, buttonLabel, disabled]);

  return (
    <>
      {button}

      {isOpen && (
        <UpsertPricingProfileRule
          pricingProfile={pricingProfile}
          pricingProfileRule={rule}
          type={type}
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          onSubmitSuccess={onSubmitSuccess}
          onRemoveSuccess={onRemoveSuccess}
        />
      )}
    </>
  );
};
